import { createModel } from '../model/index.js';
import model from './OCSearchRequest.model.js';
const OCSearchRequestModel = createModel(model);
export default class OCSearchRequest extends OCSearchRequestModel {
    getWidgetInfo(widgetId) {
        return this.getWidgetItems()?.find((widget) => widget.rfk_id && widget.rfk_id === widgetId);
    }
    addWidgets(items) {
        items.forEach((item) => this.addWidgetItem(item));
        return this;
    }
}
